import React from 'react';
import '../css/slider.css';

export default function Switch({ value, onChange, disabled }) {
	return <label className="switch">
		<input type="checkbox" checked={value} disabled={disabled} onChange={onChange} hidden />
		<span className="slider btn"></span>
	</label>;
}
